<template>
    <div id="editTags" v-if="!isHidden">
        <div class="overlayFullscreen">
            <div class="overlayContainer">
                
                <OverlayHeader v-bind:title="title"/>

                <div class="contentWrapper">
                    
                    <div class="left">
                        <h3 class="headline">Alle Tags</h3>
                        <div class="tags" v-bind:key="tag.id" v-for="tag in tags">
                            <IconBase class="icon" iconName="Tag löschen" width="32" height="32" @onIconClicked="onDeleteTag(tag)"><IconDelete /></IconBase>
                            <Tag v-bind:tag="tag" v-bind:isSelected="tag == currentTag" @onClicked="onTagClicked(tag)" />
							<div class="numberOfSlides">({{getNumSlidesString(tag)}})</div>
                        </div>
                    </div>

                    <div class="right">
                        <h3 class="headline">{{isNewTag ? HEADLINE_NEW : HEADLINE_EDIT}}</h3>
                        <input type="text" 
                            ref="textInput"
                            v-model="currentTagName" 
                            placeholder="Name" 
                            v-on:keyup.enter="onEditTag">
                        <div class="buttons">
                            <div class="button" v-on:click.stop.prevent="onEditTag">Speichern</div>
                            <div class="button" v-on:click.stop.prevent="onCancelEdit">Abbrechen</div>
                        </div>
                    </div>

                </div>
                
                <div class="saveCancelButtons">
                    <div class="button" v-on:click.stop.prevent="onExit">
                        <p>Schliessen</p>
                    </div>
                </div>

                <div class="deleteDialog" v-show="showDeleteDialog">
                    <div class="deleteText">
                        <p>Sind Sie sicher, dass Sie den Tag</p>
                        <p class="deleteTagName">{{currentTag.name}}</p>
                        <p>löschen wollen?</p>
						<p>Der Tag ist mit {{getNumSlidesString(currentTag)}} verknüpft.</p>
                    </div>
			        <div class="buttonGroup">
				        <button class="button" v-on:click.stop.prevent="deleteTag">Ja</button>
				        <button class="button" v-on:click.stop.prevent="onCancelDelete">Nein</button>
			        </div>
		        </div>

            </div>

        </div>
    </div>
</template>

<script>
import {EventBus} from '@/services/EventBus.js';
import OverlayHeader from '@/components/layout/OverlayHeader.vue';
import ContentLoader from '@/services/ContentLoader.js';
import Tag from '@/components/tags/Tag.vue';
import IconBase from '@/components/icons/IconBase.vue';
import IconDelete from '@/components/icons/IconDelete.vue';

export default {
    name: "EditTags",
    components: {
        OverlayHeader,
        Tag,
        IconBase,
        IconDelete
	},
    data() {
        return {
            isHidden: true,
            title: 'Tags bearbeiten',
            tags: [],
            currentTagName: '',
            currentTag: {},
            showDeleteDialog: false,
            isNewTag: true,
            tagsUpdated: false
        }
    },
    methods: {
		getNumSlidesString(tag) {
			if(tag == undefined) return "";
			var numSlides = this.getNumSlides(tag);
			return (numSlides == 1) ? numSlides + " Slide" : numSlides + " Slides";
		},
		getNumSlides(tag) {
			if(tag.model_slides == undefined || tag.wall_slides == undefined) return 0;
			else return tag.model_slides.length + tag.wall_slides.length;
		},
        onTagClicked(tag) {
            this.isNewTag = false;
            this.currentTagName = tag.name;
            this.currentTag = tag;
            this.$refs.textInput.focus();
        },
        onCancelEdit() {
            this.currentTag = {};
            this.currentTagName = '';
            this.isNewTag = true;
        },
        onEditTag() {
            if(this.isNewTag) {
                this.createNewTag();
            } else {
                this.renameTag();
            }
        },
        async renameTag() {
            this.currentTag.name = this.currentTagName;
            await ContentLoader.updateTag(this.currentTag);
            this.tagsUpdated = true;
            this.currentTag = {};
            this.currentTagName = '';
            this.isNewTag = true;
            this.loadTags();
        },
        async createNewTag() {
            var tag = {};
            tag.name = this.currentTagName;
            await ContentLoader.createNewTag(tag);
            this.tagsUpdated = true;
            this.currentTagName = '';
            this.loadTags();
        },
        onDeleteTag(tag) {
            this.currentTag = tag;
            this.showDeleteDialog = true;
        },
        onCancelDelete() {
            this.currentTag = {};
            this.showDeleteDialog = false;
        },
        async deleteTag() {
            this.showDeleteDialog = false;
            await ContentLoader.deleteTag(this.currentTag);
            this.tagsUpdated = true;
            this.currentTag = {};
            this.loadTags();
        },
        onExit() {
            EventBus.$emit('onUpdateTags', this.tagsUpdated);
            this.isHidden=true;
        },
        async loadTags() {
            this.tags = await ContentLoader.loadTags();
        }
    },
    mounted() {
        EventBus.$on('onEditTags', e => {
            console.log("-> on edit tags: "+e);
            this.isHidden = false;
            this.currentTagName = '';
            this.showDeleteDialog = false;
            this.isNewTag = true;
            this.tagsUpdated = false;
        });
    },
    async created() {
        this.HEADLINE_NEW = 'Neuen Tag erstellen';
        this.HEADLINE_EDIT = 'Tag umbenennen';
        await this.loadTags();
    }
}
</script>

<style scoped>

    .contentWrapper {
        display: flex;
        justify-content: space-around;
    }

    .overlayContainer {
        width: 60%;
        min-width: 800px;
        max-width: 1200px;
        /*height: 80%;*/
    }
    
    .left, .right {
        height: 100%;
        margin: 10px;
        padding: 5px;
    }

    .left {
        width: 50%;
    }
    .right {
        width: 40%;
    }
    .right .buttons {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .right .button {
        width: 120px;
        margin-left: 0;
        margin-top: 0;
    }

    .tags {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .icon {
		margin: 5px 20px 0px 0px;
	}

    .deleteDialog {
		display: flex;
        flex-direction: column;
        justify-content: center;
	}
	
	.deleteText {
		font-size: 25px;
	}

    .deleteTagName {
        font-family: "BrownLLWeb-Bold", Helvetica, sans-serif;
		font-weight: bold;
        color: #0088FF;
    }

    .buttons .button {
        margin-right: 20px;
    }

	.numberOfSlides {
		margin-top: 12px;
		margin-left: 5px;
		color: grey;
	}
    
</style>